export default {
  getLoading: (state) => state.loading,
  getJokes: (state) => state.jokes,
  getCategories: (state) => state.categories,
  getFlags: (state) => state.flags,
};
